<!-- 编辑文字 -->
<template>
  <div>
    <div>
      <van-field
        class="text-textfield-view"
        v-model="text"
        rows="1"
        autosize
        label=""
        size="large"
        type="textarea"
        placeholder="请输入内容"
        @input="changeValue"
      />
    </div>
    <div class="editor-save-view">
      <div class="editor-save" @click="save">确 定</div>
    </div>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import {mapState, mapGetters} from 'vuex'
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data () {
    // 这里存放数据
    return {
      text: '',
      cData: {}
    }
  },
  // 监听属性 类似于data概念
  computed: {
    ...mapState({
      activeElementUUID: state => state.editor.activeElementUUID
    }),
    ...mapGetters([
      'projectData',
      'getActiveElementUUID'
    ]),
  },
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    save() {
      if (!this.projectData.elements) {
        return
      }
      var e = this.projectData.elements.find(v => {return v.uuid === this.getActiveElementUUID})
      e.propsValue.text = this.text;
      this.$store.commit('setPrjectData', this.projectData)
      this.$router.go(-1);
    },
    changeValue(value) {
      
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {
    if (!this.projectData.elements) {
      return
    }
    var e = this.projectData.elements.find(v => {return v.uuid === this.getActiveElementUUID})
    this.text = e.propsValue.text;
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {},
  beforeCreate () {}, // 生命周期 - 创建之前
  beforeMount () {}, // 生命周期 - 挂载之前
  beforeUpdate () {}, // 生命周期 - 更新之前
  updated () {}, // 生命周期 - 更新之后
  beforeDestroy () {}, // 生命周期 - 销毁之前
  destroyed () {}, // 生命周期 - 销毁完成
  activated () {} // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style>
.van-field__control {
  font-size: 13px;
  line-height: 15px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #6E7580;
}
.text-textfield-view {
  padding: 15px;
  min-height: 135px;
  background: #FFFFFF;
}
.editor-save-view {
  padding: 0 30px;
  margin-top: 58px;
}
.editor-save {  
  text-align: center;
  background: var(--bgcolor);
  border-radius: 22px;
  height: 44px;  
  font-size: 17px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #FFFFFF;
  line-height: 44px;
}
</style>
